// // src/config/supabase.ts
// // Matching mobile app configuration but adapted for web browsers
// import { createClient } from '@supabase/supabase-js';

// // const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
// const supabaseUrl = "https://mjfyymsfzbxialbktzwc.supabase.co";
// const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1qZnl5bXNmemJ4aWFsYmt0endjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzNzAyMjcsImV4cCI6MjA2Njk0NjIyN30.jcoiDOqMvJjb7qjLOOv434Zy7cgQ8m3J13yc8TPeIpQ";
// // const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// if (!supabaseUrl || !supabaseAnonKey) {
//   throw new Error('Missing Supabase environment variables');
// }

// // CRITICAL FIX: Disable Supabase's lock mechanism to prevent AbortErrors
// // The browser's navigator.locks API is causing AbortErrors in development
// // Mobile app doesn't have this issue as React Native doesn't use browser locks
// // This polyfill makes locks a no-op, allowing Supabase to work without locking
// if (typeof navigator !== 'undefined' && !navigator.locks) {
//   (navigator as any).locks = {
//     request: (_name: string, _options: any, callback: () => any) => {
//       // Immediately execute the callback without actual locking
//       return Promise.resolve(callback());
//     },
//   };
// }

// // Custom storage adapter for browsers (matching mobile app's SecureStore pattern)
// const BrowserStorageAdapter = {
//   getItem: (key: string) => {
//     try {
//       return window.localStorage.getItem(key);
//     } catch (error) {
//       console.error('Storage getItem error:', error);
//       return null;
//     }
//   },
//   setItem: (key: string, value: string) => {
//     try {
//       window.localStorage.setItem(key, value);
//     } catch (error) {
//       console.error('Storage setItem error:', error);
//     }
//   },
//   removeItem: (key: string) => {
//     try {
//       window.localStorage.removeItem(key);
//     } catch (error) {
//       console.error('Storage removeItem error:', error);
//     }
//   },
// };

// // Create Supabase client with same config as mobile app
// export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
//   auth: {
//     storage: BrowserStorageAdapter,
//     autoRefreshToken: true,
//     persistSession: true,
//     detectSessionInUrl: true,
//     // Disable storage lock to prevent AbortErrors
//     storageKey: 'majengo-auth',
//   },
//   global: {
//     headers: {
//       'x-application-name': 'majengo-web',
//     },
//   },
// });

// console.log('✅ Supabase client initialized successfully');
// src/config/supabase.ts
// Matching mobile app configuration but adapted for web browsers
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://mjfyymsfzbxialbktzwc.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1qZnl5bXNmemJ4aWFsYmt0endjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzNzAyMjcsImV4cCI6MjA2Njk0NjIyN30.jcoiDOqMvJjb7qjLOOv434Zy7cgQ8m3J13yc8TPeIpQ";

// CRITICAL FIX: Completely disable the locks API to prevent AbortErrors
// This overrides the locks API before Supabase tries to use it
if (typeof navigator !== 'undefined') {
  // Override the entire locks object to prevent any lock attempts
  Object.defineProperty(navigator, 'locks', {
    get: () => undefined,
    configurable: true,
  });
}

// Custom storage adapter for browsers
const BrowserStorageAdapter = {
  getItem: (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Storage getItem error:', error);
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Storage setItem error:', error);
    }
  },
  removeItem: (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Storage removeItem error:', error);
    }
  },
};

// Create Supabase client with locks completely disabled
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: BrowserStorageAdapter,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'majengo-auth',
    // Disable all lock-related features
    // lock: false,
  },
  global: {
    headers: {
      'x-application-name': 'majengo-web',
    },
    // Disable fetch retries that might cause lock issues
    fetch: (url, options) => {
      return fetch(url, {
        ...options,
        // Prevent any abort signals from being passed
        signal: undefined,
      });
    },
  },
});

console.log('✅ Supabase client initialized successfully');